import React, { useState, useEffect } from 'react';
import { DataGrid, GridColDef, GridToolbarContainer } from '@mui/x-data-grid';
import { Button, Grid, TextField, Autocomplete, FormControl, Box } from "@mui/material";
import { Download } from '@mui/icons-material';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { url } from 'inspector';
import FullScreenLoader from '../../../../layout/FullScreenLoader';


interface CustomState {
    [key: string]: boolean
}
type Mes = {
    Nombre: string;
    id: string;
    ini: string;
    fin: string;
};

type Anio = {
    Nombre: string;
    id: string;
};
type Periodo = {
    option: string;
    value: string;
    anio: number;
    mes: number;
};

const MontosAEP = (
    { }: {}) => {

    const customLocaleText = {
        noRowsLabel: 'No se encontraron resultados',
        noResultsOverlayLabel: 'Resultados no encontrados',
        MuiTablePagination: {
            labelDisplayedRows: ({ from, to, count }: { from: any, to: any, count: any }) =>
                `${from} - ${to} de ${count}`,
            getItemAriaLabel: (type: any) => {
                if (type === 'first') {
                    return 'Primera página';
                }
                if (type === 'last') {
                    return 'Última página';
                }
                if (type === 'next') {
                    return 'Página siguiente';
                }
                // if (type === 'previous') {
                return 'Página anterior';
            },
            labelRowsPerPage: 'Registros:',
            toolbar: {
                searchTooltip: 'Buscar…',
            },
        },
        footerRowSelected: (count: any) =>
            count > 1
                ? `${count.toLocaleString()} filas seleccionadas`
                : `${count.toLocaleString()} fila seleccionada`,
    };

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [fondos, setFondos] = useState<Anio[]>([]);
    const [selectedFon, setSelectedFon] = useState<string[]>([]);
    const [anioInicio, setAnioInicio] = useState("");
    const [mesInicio, setMesInicio] = useState("");
    const [anioFin, setAnioFin] = useState("");
    const [mesFin, setMesFin] = useState("");
    const [fechaFin, setFechaFin] = useState<Periodo | null>(null);
    const [fechaInicio, setFechaInicio] = useState<Periodo | null>(null);
    const [periodos, setPeriodos] = useState<Periodo[]>([]);
    const [municipios, setMunicipios] = useState([
        { Nombre: "AGUALEGUAS", id: "11" },
        { Nombre: "ALDAMAS, LOS", id: "12" },
        { Nombre: "ALLENDE", id: "13" },
        { Nombre: "ANAHUAC", id: "14" },
        { Nombre: "ABASOLO", id: "15" },
        { Nombre: "ARAMBERRI", id: "16" },
        { Nombre: "APODACA", id: "17" },
        { Nombre: "BUSTAMANTE", id: "18" },
        { Nombre: "CADEREYTA JIMENEZ", id: "19" },
        { Nombre: "CARMEN", id: "20" },
        { Nombre: "CHINA", id: "21" },
        { Nombre: "CIENEGA DE FLORES", id: "22" },
        { Nombre: "CERRALVO", id: "23" },
        { Nombre: "DOCTOR ARROYO", id: "25" },
        { Nombre: "DOCTOR GONZALEZ", id: "26" },
        { Nombre: "DOCTOR COSS", id: "27" },
        { Nombre: "GUADALUPE", id: "28" },
        { Nombre: "GALEANA", id: "29" },
        { Nombre: "GARCIA", id: "30" },
        { Nombre: "SAN PEDRO GARZA GARCIA", id: "31" },
        { Nombre: "GENERAL BRAVO", id: "32" },
        { Nombre: "GENERAL ESCOBEDO", id: "33" },
        { Nombre: "GENERAL TERAN", id: "34" },
        { Nombre: "GENERAL TREVIÑO", id: "35" },
        { Nombre: "GENERAL ZUAZUA", id: "36" },
        { Nombre: "HERRERAS, LOS", id: "37" },
        { Nombre: "HIGUERAS", id: "38" },
        { Nombre: "HIDALGO", id: "39" },
        { Nombre: "HUALAHUISES", id: "40" },
        { Nombre: "ITURBIDE", id: "41" },
        { Nombre: "JUAREZ", id: "42" },
        { Nombre: "LAMPAZOS DE NARANJO", id: "43" },
        { Nombre: "LINARES", id: "44" },
        { Nombre: "MONTEMORELOS", id: "45" },
        { Nombre: "MARIN", id: "46" },
        { Nombre: "MINA", id: "47" },
        { Nombre: "MIER Y NORIEGA", id: "48" },
        { Nombre: "MELCHOR OCAMPO", id: "49" },
        { Nombre: "PARAS", id: "50" },
        { Nombre: "PESQUERIA", id: "51" },
        { Nombre: "RAMONES, LOS", id: "52" },
        { Nombre: "RAYONES", id: "53" },
        { Nombre: "SABINAS HIDALGO", id: "54" },
        { Nombre: "SALINAS VICTORIA", id: "55" },
        { Nombre: "SANTIAGO", id: "56" },
        { Nombre: "SANTA CATARINA", id: "57" },
        { Nombre: "SAN NICOLAS DE LOS GARZA", id: "58" },
        { Nombre: "VALLECILLO", id: "59" },
        { Nombre: "VILLALDAMA", id: "60" },
        { Nombre: "GENERAL ZARAGOZA", id: "61" },
        { Nombre: "MONTERREY", id: "70" }
    ]);
    const [selectedMun, setSelectedMun] = useState(municipios.map(m => m.id));
    const [anios, setAnios] = useState<Anio[]>([]);
    const [meses, setMeses] = useState<Mes[]>([]);
    const mesesTexto = [
        { id: 1, nombre: "Enero" },
        { id: 2, nombre: "Febrero" },
        { id: 3, nombre: "Marzo" },
        { id: 4, nombre: "Abril" },
        { id: 5, nombre: "Mayo" },
        { id: 6, nombre: "Junio" },
        { id: 7, nombre: "Julio" },
        { id: 8, nombre: "Agosto" },
        { id: 9, nombre: "Septiembre" },
        { id: 10, nombre: "Octubre" },
        { id: 11, nombre: "Noviembre" },
        { id: 12, nombre: "Diciembre" },
    ];

    const formatNumber = (value: any) => {
        if (!value) return '';
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const columns: GridColDef[] = [
        {
            field: "municipio",
            disableExport: true,
            headerName: "Municipio",
            sortable: false,
            minWidth: 250,
            renderCell: (cellValues: any) => {
                return <p>{cellValues.row.municipio}</p>;
            },
        },
        {
            field: "FOULT",
            disableExport: true,
            headerName: "Fondo de Ultracrecimiento Municipal",
            sortable: false,
            flex: 1,
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.value)}</p>;
            },
        },
        {
            field: "FODES",
            disableExport: true,
            headerName: "Fondos Descentralizados",
            sortable: false,
            flex: 1,
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.value)}</p>;
            },
        },
        {
            field: "FOSEGMUN",
            disableExport: true,
            headerName: "Fondos de Seguridad para los Municipios",
            sortable: false,
            flex: 1,
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.value)}</p>;
            },
        },
        {
            field: "FOINMUN",
            disableExport: true,
            headerName: "Fondo de Infraestructura para los Municipios",
            sortable: false,
            flex: 1,
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.value)}</p>;
            },
        },
        {
            field: "total_monto",
            headerName: "TOTAL",
            minWidth: 300,
            headerAlign: "center",
            align: "right",
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.value)}</p>;
            },
        }
    ];

    const filteredColumns = columns.filter(col =>
        rows.some(row => row[col.field] !== undefined)
    );

    const fixedColumns = ["municipio", "total_monto"];

    const sortedColumns = filteredColumns.sort((a, b) => {
        const fondosVisibles = fondos.map(fondo => fondo.Nombre);
        const aIndex = fixedColumns.includes(a.field)
            ? fixedColumns.indexOf(a.field) === 0
                ? -Infinity // "municipio" siempre primero
                : Infinity // "total" siempre al final
            : fondosVisibles.indexOf(a.field); // Ordenar según `fondos`

        const bIndex = fixedColumns.includes(b.field)
            ? fixedColumns.indexOf(b.field) === 0
                ? -Infinity
                : Infinity
            : fondosVisibles.indexOf(b.field);

        return aIndex - bIndex;
    });

    const filteredColumnsNumber = columns.filter(col =>
        rows.some(row => row[col.field] !== undefined && !isNaN(parseFloat(row[col.field])))
    );

    // Crear la fila de totales solo con las columnas filtradas
    const totalRow = {
        id: "total",
        municipio: "TOTAL",
        ...Object.fromEntries(filteredColumnsNumber.map(col => [col.field, rows.reduce((sum, row) => sum + (parseFloat(row[col.field]) || 0), 0)]))
    };

    const blankRow = {
        id: "blank",
        municipio: "",
        ...Object.fromEntries(filteredColumnsNumber.map(col => [col.field, ""]))
    };

    const noteRow = {
        id: "note",
        municipio: "Nota: La suma de los totales puede no coincidir debido a redondeos.",
        ...Object.fromEntries(filteredColumnsNumber.map(col => [col.field, null]))
    };

    const consulta = async () => {
        setLoading(true)
        const url =
            tipo === 4
                ? "/public/consulta/ae/periodo"
                : "/public/consulta-aportaciones-estatales";
        const data =
            tipo === 4
                ? {
                    "atributos": selectedFon,
                    "mesInicio": mesInicio,
                    "anioInicio": anioInicio,
                    "mesFin": mesFin,
                    "anioFin": anioFin,
                    "municipios": selectedMun
                }
                : {
                    "atributos": selectedFon,
                    "inicio": mes,
                    "fin": mesFin,
                    "anio": anio,
                    "tipo": tipo,
                    "municipios": selectedMun
                };
        var response = await axios({
            method: "post",
            data: data
            ,
            url: process.env.REACT_APP_APPLICATION_ENDPOINT + url,
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then(({ data }) => {
                setLoading(false);
                if (data.data) {
                    setRows(data.data)
                } else {
                    setLoading(false)
                    return false;
                }
                return data.data;
            })
            .catch(function (error) {
                setRows([]);
                setLoading(false)
                const mensaje =
                    error?.response?.data?.error ||
                    error?.response?.data?.message ||
                    error?.message ||
                    'Ocurrió un error inesperado';

                Swal.fire({
                    icon: 'error',
                    title: 'Error en la consulta',
                    text: mensaje,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
                return false;
            });
        return response;
    }


    const getDatos = async (tipo: number) => {
        setLoading(true);

        const url =
            tipo === 4
                ? "/public/consulta/ae/periodo-total"
                : "/public/consulta/aniosAE?tipo=" + tipo;

        await axios({
            method: "get",
            url: process.env.REACT_APP_APPLICATION_ENDPOINT! + url,
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        })
            .then(({ data }) => {
                setLoading(false);

                if (data.length === 0) {
                    setAnios([]);
                    setPeriodos([]);
                    return;
                }

                // ===============================
                // Consulta de Periodo Total
                // ===============================
                if (tipo === 4) {
                    setPeriodos(data);
                    return;
                }

                // ===============================
                // Consulta de Años
                // ===============================
                const formattedAnios = data.map((item: { anio: number }) => ({
                    Nombre: item.anio.toString(),
                    id: item.anio.toString(),
                }));

                setAnios(formattedAnios);

                const maxAnio = Math.max(
                    ...data.map((item: { anio: number }) => item.anio)
                );

                if (tipo !== 3) {
                    getMeses(maxAnio);
                }
            })
            .catch((error) => {
                setRows([]);
                setAnios([]);
                setPeriodos([]);
                setLoading(false);

                const mensaje =
                    error?.response?.data?.error ||
                    error?.response?.data?.message ||
                    error?.message ||
                    "Ocurrió un error inesperado";

                Swal.fire({
                    icon: "error",
                    title: "Error en la consulta",
                    text: mensaje,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
            });
    };
    const getMeses = async (anio: number) => {
        try {
            if (tipo === 3 || tipo === 4) return;
            const response = await axios.post(
                process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/periodos", {
                anio,
                tipo: tipo
            });
            const data = response.data;

            setMeses(data)
        } catch (error: any) {
            const mensaje =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'Ocurrió un error inesperado';

            Swal.fire({
                icon: 'error',
                title: 'Error en la consulta',
                text: mensaje,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        }
    };
    const getFondos = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/fondos/aportaciones_estatales"
            );
            const data = response.data;
            setFondos(data);
            setSelectedFon([]);
        } catch (error: any) {
            const mensaje =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'Ocurrió un error inesperado';

            Swal.fire({
                icon: 'error',
                title: 'Error en la consulta',
                text: mensaje,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        }
    };
    const todosFondos = [{ id: "all", Nombre: "Todos los Fondos" }, ...fondos];
    const todosMunicipios = [{ id: "all", Nombre: "Todos los Municipios" }, ...municipios];
    const [tipo, setTipo] = useState(1);
    const [mes, setMes] = useState("");
    const [anio, setAnio] = useState("");

    const handleChangeAnio = (event: any, newValue: any) => {
        const selectedId = newValue?.id ? newValue?.id : "";
        const selectedItem = anios.find((item) => item.id === selectedId);

        if (selectedItem) {
            setAnio(selectedItem.id);
            if (tipo !== 3) {
                getMeses(selectedItem.id as unknown as number);
                setMes("")
            } else {
                buscarFondosPorFecha(selectedItem.id, "1", "12");
                setMes("1")
            }
        }
    };

    const handleChangeMes = (event: any, newValue: any) => {
        const selectedId = newValue?.id ? newValue?.id : "";
        const selectedItem = meses.find((item) => item.id === selectedId);

        if (selectedItem) {
            if (tipo === 2) {
                setMes(selectedItem?.ini);
                setMesFin(selectedItem?.fin);
                buscarFondosPorFecha(anio, selectedItem?.ini, selectedItem?.fin);  // Filtro por mes
            } else {
                setMes(selectedItem.id);
                setMesFin(selectedItem.id);
                buscarFondosPorFecha(anio, selectedItem.id, selectedItem.id);  // Filtro por mes
            }
        } else {
            setMes("1");
            setMesFin("12");
        }
    };

    const handleChangeType = (typeVal: number) => {
        setTipo(typeVal);
        getDatos(typeVal);
        setMesInicio("");
        setAnioInicio("");
        setMesFin("");
        setAnioFin("");
        setFechaInicio(null);
        setFechaFin(null);
        setRows([])
        if (typeVal == 1) {
            setAnio("")
            setMes("")
        }
        if (typeVal == 2) {
            setAnio("")
            setMes("")
        }
        if (typeVal == 3) {
            setMeses([])
            setAnio("")
            setMes("1");
            setMesFin("12");
        }
        if (typeVal == 4) {
            setMeses([])
            setAnio("")
            setMes("1");
            setMesFin("12");
        }
    };

    const buscarFondosPorFecha = async (anio: string, mesInicio: string, mesFin: string) => {

        const url =
            tipo === 4
                ? "/public/consulta/ae/periodo-fondos"
                : "/public/consulta/filtrofondosAE";
        try {
            let response;

            if (tipo === 4) {
                const [anioInicio, mesInicioValor] = mesInicio.split("-");
                const [anioFin, mesFinValor] = mesFin.split("-");
                response = await axios.post(
                    `${process.env.REACT_APP_APPLICATION_ENDPOINT}${url}`,
                    {
                        mesInicio: mesInicioValor,
                        anioInicio,
                        mesFin: mesFinValor,
                        anioFin,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*"
                        },
                    }
                );
            } else {
                response = await axios.get(
                    `${process.env.REACT_APP_APPLICATION_ENDPOINT}${url}`,
                    {
                        params: {
                            anio,
                            mesInicio,
                            mesFin,
                        },
                        headers: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*"
                        },
                    }
                );
            }
            // Actualizar la selección de fondos
            setSelectedFon([]);
            const data = response.data;
            setFondos(data)
            setRows([])
        } catch (error: any) {
            const mensaje =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'Ocurrió un error inesperado';

            Swal.fire({
                icon: 'error',
                title: 'Error en la consulta',
                text: mensaje,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        }
    };


    useEffect(() => {
        getDatos(1);
        getFondos();
    }, []);

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <Button
                    startIcon={<Download />}
                    onClick={exportToExcel}
                    variant="contained"
                    color="primary"
                >
                    Exportar a Excel
                </Button>
            </GridToolbarContainer>
        );
    };

    const exportToExcel = async () => {
        setLoading(true)
        const generateExcelFileName = () => {
            let nombreReporte = "Reporte ";
            if (tipo === 1) {
                const mesSeleccionado = meses.find(m => m.id === mes);
                nombreReporte += mesSeleccionado ? `Mensual ${mesSeleccionado.Nombre} ${anio}` : `Mensual ${anio}`;
                nombreTab = "";
            } else if (tipo === 2) {
                const trimestreSeleccionado = meses.find(t => t.ini === mes);
                nombreReporte += trimestreSeleccionado ? `Trimestral ${trimestreSeleccionado.Nombre} ${anio}` : `Trimestral ${anio}`;
            } else if (tipo === 3) {
                nombreReporte += `Anual ${anio}`;
            } else if (tipo === 4) {
                nombreReporte += `Perido ${fechaInicio?.option} - ${fechaFin?.option}`;
            }
            return `${nombreReporte}.xlsx`;
        };

        const wb = XLSX.utils.book_new();
        if (tipo !== 4) {
            const totalRows = [...rows, totalRow, blankRow, noteRow];
            const formattedData = totalRows.map((row: any) => {
                const formattedRow: any = {};
                filteredColumns.forEach((col: any) => {
                    let value = row[col.field];

                    // Si es número, lo guardamos como tal
                    if (!isNaN(value) && value !== null && value !== "") {
                        formattedRow[col.headerName] = Number(value);
                    } else {
                        formattedRow[col.headerName] = value;
                    }
                });
                return formattedRow;
            });
            const ws = XLSX.utils.json_to_sheet(formattedData);
            Object.keys(ws).forEach((cell) => {
                if (cell[0] === "!") return; // metadata
                const cellObj = ws[cell];
                if (typeof cellObj.v === "number") {
                    cellObj.t = "n";          // tipo number
                    cellObj.z = "#,##0";      // formato con separador de miles
                }
            })
            var nombreTab = "";
            let nombreReporte = "Reporte ";
            if (tipo === 1) {
                nombreTab = "Mensual";
            } else if (tipo === 2) {
                nombreTab = "Trimestral";
            } else if (tipo === 3) {
                nombreTab = "Anual";
            } else if (tipo === 4) {
                nombreTab = "Periodo";
            }
            XLSX.utils.book_append_sheet(wb, ws, nombreTab);
        }

        if (tipo === 2) {
            const trimestre = meses.find(t => t.ini === mes);
            if (trimestre) {
                const inicio = parseInt(trimestre.ini);
                const fin = parseInt(trimestre.fin);

                for (let m = inicio; m <= fin; m++) {
                    try {
                        const mesActual = mesesTexto.find(mi => mi.id === m);
                        const response = await axios({
                            method: "post",
                            data: {
                                atributos: selectedFon,
                                inicio: m.toString(),
                                fin: m.toString(),
                                anio,
                                tipo: 1,
                                municipios: selectedMun
                            },
                            url: process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta-aportaciones-estatales",
                            headers: {
                                "Content-Type": "application/json",
                                "Access-Control-Allow-Origin": "*"
                            },
                        });

                        const dataMensual = response.data.data || [];
                        const formattedMensual = dataMensual.map((row: any) => {
                            const formattedRow: any = {};
                            filteredColumns.forEach((col: any) => {
                                let value = row[col.field];

                                // Si es número, lo guardamos como tal
                                if (!isNaN(value) && value !== null && value !== "") {
                                    formattedRow[col.headerName] = Number(value);
                                } else {
                                    formattedRow[col.headerName] = value;
                                }
                            });
                            return formattedRow;
                        });

                        const totalRow: any = {};
                        filteredColumns.forEach((col, index) => {
                            const header = col?.headerName;

                            if (!header) return; // Saltar columnas sin headerName

                            if (index === 0) {
                                totalRow[header] = "TOTAL";
                            } else {
                                const sum = formattedMensual.reduce((acc: any, row: any) => {
                                    const val = parseFloat(row?.[header]);
                                    return acc + (isNaN(val) ? 0 : val);
                                }, 0);
                                totalRow[header] = Math.round(sum);
                            }
                        });

                        const blankRowPeriodo: any = {};

                        filteredColumns.forEach((col: any) => {
                            blankRowPeriodo[col.headerName] = "";
                        });

                        const noteRowPeriodo: any = {};

                        filteredColumns.forEach((col: any) => {
                            noteRowPeriodo[col.headerName] = null;
                        });

                        // Primera columna
                        noteRowPeriodo[filteredColumns[0].headerName!] = "Nota:";

                        // Segunda columna (el texto de la nota)
                        noteRowPeriodo[filteredColumns[1].headerName!] = "La suma de los totales puede no coincidir debido a redondeos.";

                        formattedMensual.push(totalRow);
                        formattedMensual.push(blankRowPeriodo);
                        formattedMensual.push(noteRowPeriodo);

                        const wsMes = XLSX.utils.json_to_sheet(formattedMensual);
                        Object.keys(wsMes).forEach((cell) => {
                            if (cell[0] === "!") return; // metadata
                            const cellObj = wsMes[cell];
                            if (typeof cellObj.v === "number") {
                                cellObj.t = "n";          // tipo number
                                cellObj.z = "#,##0";      // formato con separador de miles
                            }
                        })
                        const nombreHoja = mesActual?.nombre || `Mes ${m}`;
                        XLSX.utils.book_append_sheet(wb, wsMes, nombreHoja);
                    } catch (err) {
                        console.error(`Error cargando datos del mes ${m}:`, err);
                    }
                }
            }
        }
        if (tipo === 4) {

            if (!mesInicio || !anioInicio) {
                Swal.fire({
                    icon: "error",
                    title: "Error en la consulta",
                    text: "Es necesario seleccionar la fecha de inicio.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
                setLoading(false)
                return;
            }

            if (!mesFin || !anioFin) {
                Swal.fire({
                    icon: "error",
                    title: "Error en la consulta",
                    text: "Es necesario seleccionar la fecha final.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
                setLoading(false)
                return;
            }
            if (!selectedFon || selectedFon.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "Error en la consulta",
                    text: "Es necesario seleccionar al menos un fondo.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
                setLoading(false)
                return;
            }

            if (!selectedMun || selectedMun.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "Error en la consulta",
                    text: "Es necesario seleccionar al menos un municipio.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
                setLoading(false)
                return;
            }

            const rowsPeriodo = await consulta();

            const filteredColumnsPeriodo = columns.filter(col =>
                rowsPeriodo.some((row: any) => row[col.field] !== undefined)
            );

            let anioActual = parseInt(anioInicio);
            let mesActual = parseInt(mesInicio);

            const anioFinal = parseInt(anioFin);
            const mesFinal = parseInt(mesFin);

            while (
                anioActual < anioFinal ||
                (anioActual === anioFinal && mesActual <= mesFinal)
            ) {
                try {
                    const nombreMes = mesesTexto.find(m => m.id === mesActual)?.nombre ?? `Mes ${mesActual}`;

                    const response = await axios({
                        method: "post",
                        url: process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta-aportaciones-estatales",
                        headers: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*"
                        },
                        data: {
                            atributos: selectedFon,
                            inicio: mesActual.toString(),
                            fin: mesActual.toString(),
                            anio: anioActual.toString(),
                            tipo: 1,
                            municipios: selectedMun
                        }
                    });

                    const dataMensual = response.data.data || [];
                    if (dataMensual.length === 0) {
                        continue;
                    }

                    const formattedMensual = dataMensual.map((row: any) => {
                        const formattedRow: any = {};

                        filteredColumnsPeriodo.forEach((col: any) => {
                            let value = row[col.field];

                            if (!isNaN(value) && value !== null && value !== "") {
                                formattedRow[col.headerName] = Number(value);
                            } else {
                                formattedRow[col.headerName] = value;
                            }
                        });

                        return formattedRow;
                    });

                    const totalRow: any = {};

                    filteredColumnsPeriodo.forEach((col, index) => {
                        const header = col.headerName;

                        if (!header) return;

                        if (index === 0) {
                            totalRow[header] = "TOTAL";
                        } else {
                            const sum = formattedMensual.reduce((acc: number, row: any) => {
                                const val = parseFloat(row?.[header]);
                                return acc + (isNaN(val) ? 0 : val);
                            }, 0);

                            totalRow[header] = Math.round(sum);
                        }
                    });

                    const blankRowPeriodo: any = {};

                    filteredColumnsPeriodo.forEach((col: any) => {
                        blankRowPeriodo[col.headerName] = "";
                    });

                    const noteRowPeriodo: any = {};

                    filteredColumnsPeriodo.forEach((col: any) => {
                        noteRowPeriodo[col.headerName] = null;
                    });

                    // Primera columna
                    noteRowPeriodo[filteredColumnsPeriodo[0].headerName!] = "Nota:";

                    // Segunda columna (el texto de la nota)
                    noteRowPeriodo[filteredColumnsPeriodo[1].headerName!] = "La suma de los totales puede no coincidir debido a redondeos.";

                    formattedMensual.push(totalRow);
                    formattedMensual.push(blankRowPeriodo);
                    formattedMensual.push(noteRowPeriodo);

                    const wsMes = XLSX.utils.json_to_sheet(formattedMensual);

                    Object.keys(wsMes).forEach(cell => {
                        if (cell.startsWith("!")) return;

                        const cellObj = wsMes[cell];

                        if (typeof cellObj.v === "number") {
                            cellObj.t = "n";
                            cellObj.z = "#,##0";
                        }
                    });

                    XLSX.utils.book_append_sheet(
                        wb,
                        wsMes,
                        `${nombreMes} ${anioActual}`
                    );

                } catch (err) {
                    console.error(`Error ${mesActual}/${anioActual}`, err);
                }

                // avanzar al siguiente mes
                mesActual++;

                if (mesActual > 12) {
                    mesActual = 1;
                    anioActual++;
                }
            }
        }

        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileName = generateExcelFileName();
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setLoading(false)
    };

    const periodosFechaInicio = fechaFin
        ? periodos.filter((p) => {
            const inicio = new Date(p.anio, p.mes - 1);
            const fin = new Date(fechaFin.anio, fechaFin.mes - 1);

            return inicio < fin;
        })
        : periodos;

    const periodosFechaFin = fechaInicio
        ? periodos.filter((p) => {
            const inicio = new Date(fechaInicio.anio, fechaInicio.mes - 1);
            const fin = new Date(p.anio, p.mes - 1);

            return fin > inicio;
        })
        : periodos;

    return (
        <Grid container xs={12}>
            {
                <FullScreenLoader loading={loading} />
            }
            <Grid container spacing={2}>
                <Grid container spacing={2} mt={2} sx={{ marginLeft: ".3rem" }}>
                    {/* Botón Mensual */}
                    <Grid item xs={12} md={2}>
                        <Button
                            fullWidth
                            color={tipo === 1 ? 'primary' : 'secondary'}
                            size="small"
                            variant="contained"
                            onClick={() => handleChangeType(1)}
                            sx={{ height: "2.3rem" }}
                        >
                            Mensual
                        </Button>
                    </Grid>

                    {/* Botón Trimestral */}
                    <Grid item xs={12} md={2}>
                        <Button
                            fullWidth
                            color={tipo === 2 ? 'primary' : 'secondary'}
                            size="small"
                            variant="contained"
                            onClick={() => handleChangeType(2)}
                            sx={{ height: "2.3rem" }}
                        >
                            Trimestral
                        </Button>
                    </Grid>

                    {/* Botón Anual */}
                    <Grid item xs={12} md={2}>
                        <Button
                            fullWidth
                            color={tipo === 3 ? 'primary' : 'secondary'}
                            size="small"
                            variant="contained"
                            onClick={() => handleChangeType(3)}
                            sx={{ height: "2.3rem" }}
                        >
                            Anual
                        </Button>
                    </Grid>

                    {/* Botón Periodo */}
                    <Grid item xs={12} md={2}>
                        <Button
                            fullWidth
                            color={tipo === 4 ? 'primary' : 'secondary'}
                            size="small"
                            variant="contained"
                            onClick={() => handleChangeType(4)}
                            sx={{ height: "2.3rem" }}
                        >
                            Periodo
                        </Button>
                    </Grid>
                </Grid>

                {tipo !== 4 && (
                    <>

                        {/* Autocomplete Año */}
                        <Grid item xs={12} md={2.9}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="anios"
                                    options={anios}
                                    getOptionLabel={(option) => option.Nombre}
                                    value={anios.find(m => m.id == anio) || null}
                                    onChange={handleChangeAnio}
                                    noOptionsText="Sin opciones"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Año"
                                            placeholder="Año"
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: 50,
                                                },
                                                '& .MuiInputLabel-root': {
                                                    fontSize: 16,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {/* Autocomplete Mes */}
                        <Grid item xs={12} md={2.9}>
                            <FormControl fullWidth size="small">
                                <Autocomplete
                                    id="meses"
                                    options={meses}
                                    getOptionLabel={(option) => option.Nombre}
                                    value={meses.find(m => m.id == mes) || null}
                                    onChange={handleChangeMes}
                                    noOptionsText="Sin opciones"
                                    renderInput={(params) => (
                                        <TextField {...params} label="Mes" placeholder="Mes" size="small"
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: 50,
                                                },
                                                '& .MuiInputLabel-root': {
                                                    fontSize: 16,
                                                },
                                            }}
                                        />
                                    )}
                                    disabled={tipo === 3}
                                />
                            </FormControl>
                        </Grid>


                    </>
                )}
                {tipo === 4 && (
                    <>
                        {/* Autocomplete Fecha Inicio */}
                        <Grid item xs={12} md={2.9}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="fechaInicio"
                                    options={periodosFechaInicio}
                                    getOptionLabel={(option) => option.option}
                                    value={fechaInicio}
                                    onChange={(_, value) => {
                                        setFechaInicio(value);

                                        if (value) {
                                            setAnioInicio(value.anio.toString());
                                            setMesInicio(value.mes.toString());


                                            if (fechaFin) {
                                                buscarFondosPorFecha(
                                                    "0",
                                                    value.value,
                                                    fechaFin.value
                                                );
                                            }

                                        } else {
                                            setAnioInicio("");
                                            setMesInicio("");
                                        }
                                    }}
                                    noOptionsText="Sin opciones"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Fecha Inicio"
                                            placeholder="Fecha Inicio"
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: 50,
                                                },
                                                '& .MuiInputLabel-root': {
                                                    fontSize: 16,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {/* Autocomplete Fecha Fin */}
                        <Grid item xs={12} md={2.9}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="fechaFin"
                                    options={periodosFechaFin}
                                    getOptionLabel={(option) => option.option}
                                    value={fechaFin}
                                    onChange={(_, value) => {
                                        setFechaFin(value);

                                        if (value) {
                                            setAnioFin(value.anio.toString());
                                            setMesFin(value.mes.toString());


                                            if (fechaInicio) {
                                                buscarFondosPorFecha(
                                                    "0",
                                                    fechaInicio.value,
                                                    value.value
                                                );
                                            }

                                        } else {
                                            setAnioFin("");
                                            setMesFin("");
                                        }

                                    }}
                                    noOptionsText="Sin opciones"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Fecha Final"
                                            placeholder="Fecha Final"
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: 50,
                                                },
                                                '& .MuiInputLabel-root': {
                                                    fontSize: 16,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </>
                )}
                <Grid item xs={12} md={3.1}>
                    <FormControl fullWidth sx={{ bgColor: "#fff" }}>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            id="fondos"
                            options={todosFondos}
                            getOptionLabel={(option) => option.Nombre}
                            value=
                            {fondos.filter(m => selectedFon.includes(m.id))}
                            onChange={(event, newValue) => {
                                if (newValue.some(item => item.id === "all")) {
                                    setSelectedFon(fondos.map(m => m.id));
                                } else { setSelectedFon(newValue.map(m => m.id)); }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Fondos" placeholder="Fondos" />)}
                            sx={{
                                width: '100%',
                                '& .MuiAutocomplete-inputRoot': {
                                    paddingTop: '2px',
                                    paddingBottom: '2px',
                                    alignItems: 'center', // centra los chips verticalmente
                                    minHeight: '50px', // altura controlada
                                },
                                '& .MuiAutocomplete-tag': {
                                    margin: '2px 4px 2px 0', // compacta los chips
                                    maxWidth: '120px', // evita que sean muy largos
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                },
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3.1}>
                    <FormControl fullWidth sx={{ bgColor: "#fff" }}>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            id="municipios"
                            options={todosMunicipios}
                            getOptionLabel={(option) => option.Nombre}
                            value=
                            {municipios.filter(m => selectedMun.includes(m.id))}
                            onChange={(event, newValue) => {
                                if (newValue.some(item => item.id === "all")) {
                                    setSelectedMun(municipios.map(m => m.id));
                                } else { setSelectedMun(newValue.map(m => m.id)); }
                            }}

                            renderInput={(params) => (
                                <TextField {...params} label="Municipios" placeholder="Municipios" />
                            )}
                            sx={{
                                width: '100%',
                                '& .MuiAutocomplete-inputRoot': {
                                    paddingTop: '2px',
                                    paddingBottom: '2px',
                                    alignItems: 'center', // centra los chips verticalmente
                                    minHeight: '50px', // altura controlada
                                },
                                '& .MuiAutocomplete-tag': {
                                    margin: '2px 4px 2px 0', // compacta los chips
                                    maxWidth: '120px', // evita que sean muy largos
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                },
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Box
                mt={2}
                width="100%"
                display="flex"
                justifyContent={{ xs: 'center', md: 'flex-start' }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={tipo !== 4 ? consulta : exportToExcel}
                    sx={{
                        width: { xs: '100%', md: '15.5%' }, // md=2
                        minHeight: 36, // altura estándar de botón size="small"
                        padding: '6px 16px', // padding típico de botones MUI small
                    }}
                >
                    {tipo === 4 ? "Exportar a Excel" : "Filtrar"}
                </Button>
            </Box>
            <Grid style={{ height: rows.length > 0 && tipo !== 4 ? 700 : 0, width: '100%' }} mt={2} mb={2}>
                {
                    rows.length > 0 && tipo !== 4 &&
                    <DataGrid
                        sx={{
                            "& .sticky-header": {
                                position: "sticky",
                                left: 0,
                                backgroundColor: "white",
                                zIndex: 2,
                            },
                            "& .sticky-column": {
                                position: "sticky",
                                left: 0,
                                backgroundColor: "white",
                                zIndex: 1,
                            },
                            "& .MuiDataGrid-cell": {
                                whiteSpace: "nowrap", minWidth: 120
                            }
                        }}
                        rows={[...rows, totalRow]}
                        columns={filteredColumns}
                        loading={loading}
                        getRowId={(row: any) => row.id}
                        localeText={customLocaleText}
                        components={{ Toolbar: CustomToolbar }}
                        disableColumnMenu
                    />
                }
            </Grid>
            <Grid container mb={2} width={"100%"} display={"flex"} justifyContent={"space-between"}>
                <Grid item xs={12} sx={{ marginBottom: "1rem" }}>
                    <p style={{ fontWeight: "bold" }}>
                        Nota: La suma de los totales puede no coincidir debido a redondeos.
                    </p>
                </Grid>
            </Grid>
        </Grid >
    );
};

export { MontosAEP };